import cjaAnalytics from 'yoda-core-components/lib/helpers/Analytics/CJAAnalytics';
import buildCJAPageViewPayload from 'yoda-core-components/lib/helpers/Analytics/CJAPageViewBuilder';
import { buildCJAError } from 'yoda-site-components/lib/analytics/CJAEventsHelper';
import * as HomePageActionTypes from '../actionTypes/HomePageActionTypes';
import * as DepartmentActionTypes from '../actionTypes/DepartmentPageActionTypes';
import constants from '../analytics/Analytics.config';

const getDeptAnalytics = (state) => {
    const { pageName = '', pageType = '' } = state?.irisData?.analytics || {};
    return { pageName, pageType };
};

const buildPagePayload = (state, pageId, section, version, name) => {
    const context = state.context || {};

    return buildCJAPageViewPayload({
        name: name || pageId,
        type: pageId,
        siteSection: section,
        category: {
            primary: section,
        },
        flags: {
            isErrorPage: !!state.ErrorPage,
            isChatAvailable: true,
        },
        tech: {
            releaseVersion: context.__RELEASEVERSION__ || '',
            version,
        },
    });
};

const CJAMiddleware = (store) => (next) => (action) => {
    if (typeof window === 'undefined') return next(action);
    if (!cjaAnalytics.isEnabled()) return next(action);

    const state = store.getState();
    let eventName = null;
    let eventData = null;

    switch (action.type) {
        case HomePageActionTypes.HOME_PAGE_LOAD_READY: {
            const contentData = state.irisData || {};
            const didAllContentLoad = Object.keys(contentData).length > 1;
            if (!didAllContentLoad) {
                const { eventName: errEvent, payload: errPayload } = buildCJAError([
                    {
                        errorID: 'MICROSITE:HOME:TEMPLATE:SERVER:FAILED',
                        errorDescription: 'Page Template Load failed',
                    },
                ]);
                cjaAnalytics.track(errEvent, errPayload);
            }
            eventName = 'pageView';
            eventData = buildPagePayload(
                state,
                constants.HOME_PAGE_ID,
                constants.siteSection.HOME,
                `apollo 1 ${constants.HOME_PAGE_ID}`
            );
            break;
        }
        case DepartmentActionTypes.DEPARTMENT_PAGE_LOAD_READY: {
            const { pageName, pageType } = getDeptAnalytics(state);
            eventName = 'pageView';
            eventData = buildPagePayload(
                state,
                constants.DEPARTMENT_PAGE_ID,
                pageName,
                `apollo 1 ${constants.DEPARTMENT_PAGE_ID}`,
                pageType ? `${pageType}:${pageName}` : pageName
            );
            break;
        }
        case HomePageActionTypes.FINDASTORE_PAGE_LOAD_READY:
            eventName = 'pageView';
            eventData = buildPagePayload(
                state,
                constants.FINDASTORE_PAGE_ID,
                constants.siteSection.FINDASTORE,
                '2017 yoda findastore'
            );
            break;
        default:
            break;
    }

    if (eventName && eventData) {
        cjaAnalytics.track(eventName, eventData);
    }

    return next(action);
};

export default CJAMiddleware;
